import React, { useEffect, useState } from "react";
import { SectionTitle, LoaderContainer } from "./AddItem.styles";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Steps from "../../../../components/Steps/Steps";
import AddItemStepCategory from "../../../../components/Steps/Items/AddItemStepCategory";
import AddItemStepSubcategory from "../../../../components/Steps/Items/AddItemStepSubcategory";
import AddItemStepItemsInfo from "../../../../components/Steps/Items/AddItemStepItemsInfo";
import AddItemStepPrintArea from "../../../../components/Steps/Items/AddItemStepPrintArea";
import AddItemStepAttributes from "../../../../components/Steps/Items/AddItemStepAttributes";
import AddItemStepPricing from "../../../../components/Steps/Items/AddItemStepPricing";
import AddItemStepComplete from "../../../../components/Steps/Items/AddItemStepComplete";
import { selectedMarketplaceItem } from "../../../../store/slices/marketplace/marketplaceSlice";

import { useLocation } from "react-router-dom";
import { getMarketplaceItemById } from "../../../../store/slices/marketplace/asyncThunks";
import AppLoader from "../../../../components/AppLoader";

const AddItem = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(1);
  const [wentThroughSubcategory, setWentThroughSubcategory] = useState(false);
  const { state } = useLocation();
  const item = useSelector(selectedMarketplaceItem);
  const action = state?.action;
  const itemId = state?.productId;
  const [photos, setPhotos] = useState([]);
  const [photosToList, setPhotosToList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (action === "edit") {
      dispatch(getMarketplaceItemById(itemId));
    }
  }, [state, dispatch, action]);

  const baseStepNames = [
    t("category"),
    t("items-info"),
    t("print-area"),
    t("attributes"),
    t("pricing"),
  ];

  const stepNames = wentThroughSubcategory
    ? [
        t("category"),
        t("subcategory"),
        t("items-info"),
        t("print-area"),
        t("attributes"),
        t("pricing"),
      ]
    : baseStepNames;

  const stepsIndicatorActive = wentThroughSubcategory
    ? activeStep
    : activeStep === 1
      ? 1
      : activeStep - 1;

  return (
    <>
      <SectionTitle>
        {action === "create" ? t("add-an-item") : t("edit-an-item")}
      </SectionTitle>
      {activeStep !== 7 && (
        <Steps
          steps={stepNames}
          activeStep={stepsIndicatorActive}
          setActiveStep={setActiveStep}
        />
      )}
      {loading && (
        <LoaderContainer>
          <AppLoader />
        </LoaderContainer>
      )}

      {!loading && (
        <>
          {activeStep === 1 && (
            <AddItemStepCategory
              action={action}
              item={item}
              onNext={() => {
                setWentThroughSubcategory(false);
                setActiveStep(3);
              }}
              onNextSubcategory={() => {
                setWentThroughSubcategory(true);
                setActiveStep(2);
              }}
            />
          )}
          {activeStep === 2 && (
            <AddItemStepSubcategory
              onBack={() => setActiveStep(1)}
              onNext={() => setActiveStep(3)}
            />
          )}
          {activeStep === 3 && (
            <AddItemStepItemsInfo
              onBack={() => setActiveStep(wentThroughSubcategory ? 2 : 1)}
              onNext={() => setActiveStep(4)}
              item={item}
              action={action}
              setPhotos={setPhotos}
              photos={photos}
              photosToList={photosToList}
              setPhotosToList={setPhotosToList}
            />
          )}
          {activeStep === 4 && (
            <AddItemStepPrintArea
              photos={photos}
              action={action}
              onBack={() => setActiveStep(3)}
              onNext={() => setActiveStep(5)}
            />
          )}
          {activeStep === 5 && (
            <AddItemStepAttributes
              photos={photos}
              action={action}
              onBack={() => setActiveStep(4)}
              onNext={() => setActiveStep(6)}
            />
          )}
          {activeStep === 6 && (
            <AddItemStepPricing
              onBack={() => setActiveStep(5)}
              onNext={() => setActiveStep(7)}
              photos={photos}
              setLoading={setLoading}
              itemId={itemId}
              action={action}
            />
          )}
        </>
      )}
      {activeStep === 7 && <AddItemStepComplete action={action} />}
    </>
  );
};

export default AddItem;
